export const limpiarRut = (rut) =>
  String(rut)
    .replace(/\./g, "")
    .replace(/-/g, "")
    .replace(/\s+/g, "")
    .toUpperCase();

export const esRutLimpioValido = (rutLimpio) => rutLimpio.length >= 2;

export const formatearRut = (rutLimpio) =>
  `${rutLimpio.slice(0, -1)}-${rutLimpio.slice(-1)}`;
